import Button from "components/shared/button";
import useTranslation from "utils/hooks/useTranslation";
import { useEffect, useState } from "react";
import {
  setLocalStorageItem,
} from "utils/helpers/localStorage";

export const Maintenance: React.FC<{
    setIsInMaintenance: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
    setIsInMaintenance
}) => {
    const { t } = useTranslation();

    const [clickCount, setClickCount] = useState<number>(0);
  
    useEffect(() => {
      if (clickCount >= 7) {
        setIsInMaintenance(false);
        setLocalStorageItem("isInMaintenanceOpened", true);
      }
    }, [clickCount]);

    return (
        <view
            data-space="40"
            data-gap="30"
            data-scroll=""
            data-background="highlight"
            data-align="center"
        >
            <group
                data-border=""
                data-radius="15"
                data-contain=""
                data-background="main-background"
                data-shrink="no"
                data-max-length="700"
            >
                <group data-space="40">
                    <Button
                        data-height="60"
                        data-radius="special"
                        data-space="20"
                        data-length="forcefit"
                        data-fit="1"
                        primary
                        text={t("FO_WELCOME_MAINTENANCE_TITLE")}
                        onClick={() => {
                            setClickCount(clickCount + 1);
                        }}
                    />
                    <space data-height="10"></space>
                    <separator data-horizontal=""></separator>
                    <group>
                        <text data-wrap="wrap">{t("FO_WELCOME_MAINTENANCE_TEXT")}</text>
                    </group>
                </group>
            </group>
        </view>
    );
};